<app-yard-trade-pricing-add-modal></app-yard-trade-pricing-add-modal>
<div class="fullcontainer">

  <div class='sheet'>
    @if (this.isError) {
      <div class="alert alert-danger">Please complete all required fields</div>
    }
    @if (this.isServerError) {
      <div class="alert alert-danger">Something went wrong. Please try again later.</div>
    }
    @if (this.isSuccess) {
      <div class="alert alert-success">Order was updated successfully</div>
    }
    <h1 class='header'>Create yard trade order</h1>
    <app-tabs>
      <app-tab title='Main Details'>
        <p><strong>Customer: {{ this.customer.name }}</strong></p>
        <br />

        <div class='form-row'>
          <div class="form-group col-md-4">
            <label for="inputEmail4">Ticket Number</label>
            <input type="text" name='name' [(ngModel)]='this.yardTrade.ticketNumber' [class.is-invalid]='!this.yardTrade.ticketNumber' class="form-control" id="inputEmail4">
          </div>
          <div class="form-group col-md-4">
            <label for="inputEmail4">Date</label>
            <input type="date" name='name' [class.is-invalid]='!this.yardTrade.date'  [(ngModel)]='this.yardTrade.date' class="form-control" id="inputEmail4">
          </div>
          <div class="form-group col-md-4">
            <input type="radio" name='name' [(ngModel)]='this.yardTrade.typeofTrade' id="inputEmail4" [value]='0'> <label>Trade In</label>
            <input type="radio" name='name' [(ngModel)]='this.yardTrade.typeofTrade' id="inputEmail4" [value]='1'>  <label for="inputEmail4">Trade Out</label>
          </div>
          <div class="form-group col-md-4">
            <label for="inputEmail4">Depot</label>
            <select class='form-control' [class.is-invalid]='this.yardTrade.depotId === -1' (change)='this.yardTrade.depotId = +$event.target.value; this.yardTrade.depot.id = this.yardTrade.depotId;'>
              <option value='-1'>Select a depot</option>
              @for (item of this.depots; track item) {
                <option [value]='item.id' [selected]='this.yardTrade.depotId === item.id'>{{ item.name }}</option>
              }
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="inputEmail4">Grade</label>
            <select class='form-control' [class.is-invalid]='this.yardTrade.gradeId === -1' (change)='this.yardTrade.gradeId = +$event.target.value;'>
              <option value='-1'>Select a grade</option>
              @for (item of this.grades; track item) {
                <option [value]='item.id' [selected]='this.yardTrade.gradeId === item.id'>{{ item.name }}</option>
              }
            </select>
          </div>
          <div class="form-group col-md-4">
            <label for="inputEmail4">Vehicle Registration</label>
            <input type="text" name='name' [(ngModel)]='this.yardTrade.vehicleReg' class="form-control" id="inputEmail4">
          </div>
          <div class="form-group col-md-4">
            <label for="inputEmail4">PO Number</label>
            <input type="text" name='name' [(ngModel)]='this.yardTrade.poNumber'  class="form-control" id="inputEmail4">
          </div>

        </div>


        <br />
        <br />

        <h2 class='header'>Weight details</h2>
        <div class='form-row'>
          <div class='form-group col-md-4'>
            <label>Gross Weight</label>
            <input type='text' [class.is-invalid]='!this.yardTrade.grossWeight' class='form-control' [(ngModel)]='this.yardTrade.grossWeight'/>
          </div>
        </div>
        <div class='form-row'>
          <div class='form-group col-md-4'>
            <label>Tare Weight</label>
            <input type='text' [class.is-invalid]='!this.yardTrade.tareWeight' class='form-control' [(ngModel)]='this.yardTrade.tareWeight'/>
          </div>
        </div>
        <div class='form-row'>
          <div class='form-group col-md-4'>
            <label>Net Weight</label>
            <input type='text' class='form-control' [value]='(this.yardTrade.grossWeight - this.yardTrade.tareWeight).toFixed(2)' readonly/>
          </div>
        </div>
      </app-tab>
      <app-tab title='Pricing Details'>
        <button class='btn btn-secondary' (click)='this.openModal("yardtradeAddItemModal")'><i class="fas fa-plus"></i> Add Custom Item</button>
        <table class="table">
          <thead>
            <th>Name</th>
            <th>Qty</th>
            <th>Unit</th>
            <th>Base Price(&pound;)</th>
            <th>Total Price(&pound;)</th>
            <th></th>
          </thead>
          <tbody>
            @for (item of this.yardTradePricing; track item) {
              <tr>
                <td>{{ item.name }}</td>
                <td>
                  <input type="number" min='0' name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.qty'>
                </td>
                <td>
                  {{ this.getUnitFromUnitId(item.unitId).name }}(s)
                </td>
                <td>
                  {{ item.price }}
                </td>
                <td>
                  {{ getTotalPrice(item).toFixed(2) }}
                </td>
              </tr>
            }
          </tbody>

        </table>
      </app-tab>
    </app-tabs>

    <button type="submit" class="btn btn-success" (click)='save()'>Save</button>&nbsp;
    <button type="button" class="btn btn-danger" routerLink='/weighbridge'>Cancel</button>
  </div>


</div>
